module.exports = __webpack_public_path__ + "img/empty.df38915f.png";